"use client";

export type GameSuccessAction = "create" | "update";

type SupportedLocale = "th" | "en" | "cn";

const STATUS_WORDS: Record<SupportedLocale, { create: string; update: string; success: string }> = {
    th: { create: "สร้าง", update: "อัปเดต", success: "สำเร็จ" },
    en: { create: "Create", update: "Update", success: "success" },
    cn: { create: "创建", update: "更新", success: "成功" },
};

function getCookieLocale(): SupportedLocale {
    if (typeof document === "undefined") {
        return "th";
    }

    const cookie = document.cookie
        .split(";")
        .map((entry) => entry.trim())
        .find((entry) => entry.startsWith("eef_locale="));

    const raw = cookie ? decodeURIComponent(cookie.slice("eef_locale=".length)).toLowerCase() : "";
    if (raw === "en" || raw === "cn" || raw === "th") {
        return raw;
    }

    return "th";
}

export function buildGameSuccessStatus(gameLabel: string, action: GameSuccessAction) {
    const locale = getCookieLocale();
    const words = STATUS_WORDS[locale];
    const actionText = action === "update" ? words.update : words.create;
    const title = `${actionText} ${gameLabel} ${words.success}`;

    return {
        title,
        message: "",
        type: "success" as const,
    };
}
